import { createSelector } from 'reselect';

const getCuriosoData = state => state.curiosoReducer;
const getCuriosoBody = state => state.curiosoReducer.curioso;

export const getCuriosoSkin = createSelector(
  [getCuriosoBody],
  curioso => curioso.skin,
);

export const getIsCuriosoSelected = createSelector(
  [getCuriosoData],
  curioso => curioso.introComplete,
);
